<script lang="ts">
  import { Alert, Loader } from '@tomra/design-system-svelte';

  let {
    title,
    message,
    loading = false
  }: { title: string; message?: string; loading?: boolean } = $props();
</script>

<div class="flex h-full items-center justify-center p-6">
  {#if loading}
    <div class="flex flex-col items-center gap-4" role="status">
      <Loader aria-hidden="true" role="presentation" />
      <p class="text-sm text-gray-600">{title}</p>
    </div>
  {:else}
    <Alert variant="destructive">
      <p>{title}</p>
      {#if message}<p class="mt-2 font-normal">{message}</p>{/if}
    </Alert>
  {/if}
</div>
